import { NavigationContainer } from "@react-navigation/native";
import react from "react";
import { Text,FlatList,StyleSheet,TouchableOpacity,Image} from "react-native";
import { View,Dimensions } from "react-native";


const Projects=props=>{
    const PrdtData=[
        {
            id:'1',
            title:'مطلب یک',
            img:require('../assets/logo.png'),
        },
        {
            id:'2',
            title:'مطلب دو',
            img:require('../assets/logo.png'),
        },
        {
            id:'3',
            title:'مطلب سه',
            img:require('../assets/logo.png'),
        },

    ]
    return(
        <View style={{backgroundColor:'#e6e6e6',flex:1,justifyContent:'center'}}>
        <FlatList
    
      
        data={PrdtData}
        style={{margin:7}}
        renderItem={(itemList)=>
            <View style={styles.listRow } >
        <TouchableOpacity onPress={()=>props.navigation.navigate('ProductsDetail',{product:itemList.item})}>            
           <Image source={itemList.item.img} style={styles.img} />
           <Text style={styles.title}>{itemList.item.title}</Text>
            
        </TouchableOpacity>
        </View>
        }
        />
        </View>
    )
}
const styles=StyleSheet.create(
    {
        listRow:{
           
            height:100,
            padding:10,
            margin:2,                       
            backgroundColor:'#fff',
            color:'#fff',
            borderRadius:6,            
            flex:1,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 0.5 },
            shadowOpacity: 0.7,
            shadowRadius: 2,       
            justifyContent: 'center',
        }
        ,
        title:{
           
            paddingRight:15,
            textAlignVertical:'top',
            padding:17,
            fontFamily:'IranSans',
            fontSize:14,
            textAlign:'right',
            
            
        }
        ,
        img:{
            width: 76,
            height: 58,
            borderRadius:3,
            resizeMode: 'contain',
            alignSelf: 'left',

           
        }
    }
)
export default Projects;